import React from "react"
import { Typography, useTheme } from "@mui/material"

import { useMemo } from "react"
import { getFeatureDetail } from "utils/feature"
import { useTranslation } from "providers/i18n"
import { Link } from "react-router-dom"
import { ImageCard } from "components/ImageCard"

export const DepartmentStoreCard = ({ data, sx, ...props }) => {
  const { t } = useTranslation()
  const { name, isFeatured } = useMemo(() => getFeatureDetail(data), [data])

  const theme = useTheme()

  const { styleOverrides = {} } =
    theme.components?.[`EmDepartmentStorePage`] || {}
  const { gridItem } = styleOverrides

  const renderSubheader = useMemo(() => {
    return (
      <>
        <Typography
          component="span"
          variant="subtitle"
          sx={{ fontSize: 12, mt: 1 }}
        >
          {t("navigation.DepartmentStore")}
        </Typography>
      </>
    )
  }, [t])

  return (
    <ImageCard
      key={data?.id}
      component={Link}
      sx={gridItem}
      to={`${data?.id}/occupants`}
      title={t(name)}
      subheader={renderSubheader}
      image={data?.properties?.icon_image}
      tag={isFeatured ? t("Highlight") : null}
      {...props}
    />
  )
}
